import { AccountInfo } from "@azure/msal-common";
import { useMsal } from "@azure/msal-react";
import { CoherenceHeader } from "@coherence-design-system/controls";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { updateCafe } from "../reducers/diningReducer";
import styles from "../styles/header.module.css";
import UpdateCafe from "./UpdateCafe/UpdateCafe";
import { UpdateCafeFormFields } from "./UpdateCafe/UpdateCafeForm";

export default () => {
  const dispatch = useDispatch();
  const { instance, accounts } = useMsal();
  const account: AccountInfo | null = accounts[0] || {};

  const methods = useForm<UpdateCafeFormFields>({ mode: "all" });

  // If you modify this, make the same changes in WrappedUpdateCafeForTesting.tsx to
  // insure that UpdateCafe tests work.
  const onUpdateCafeSubmit = (data: UpdateCafeFormFields) => {
    dispatch(updateCafe(data));
  };

  return (
    <FormProvider {...methods}>
      <CoherenceHeader
        headerLabel="Chef's Menu"
        appNameSettings={{
          label: "Chef's Menu",
          ariaLabel: "Chef's Menu home page",
        }}
        farRightSettings={{
          profileSettings: {
            panelSettings: {
              emailAddress: account ? account.username : "",
              fullName: account ? account.name : "",
              imageUrl: undefined,
              onViewAccount: () => console.log("Handled the profile"),
              onLogOut: () => instance.logout(),
              logOutLink: "",
            },
          },

          settingsSettings: account
            ? {
                panelSettings: {
                  body: <UpdateCafe />,
                  className: styles.settings,
                  onRenderFooter: {
                    primaryButton: {
                      text: "Save",
                      onAction: () => {
                        methods.handleSubmit(onUpdateCafeSubmit)();
                      },
                    },
                    secondaryButton: {
                      text: "Cancel",
                      onAction: () => {
                        const panelCloseButton = document.getElementsByClassName(
                          "ms-PanelAction-close",
                        )[0] as HTMLElement;
                        panelCloseButton?.click();
                      },
                    },
                  },
                },
              }
            : undefined,
        }}
        onDismissOpenedPanel={() => {
          return;
        }}
      />
    </FormProvider>
  );
};
